import React, { memo } from 'react';

const WelcomeScreen = () => {
  return (
    <div className="welcome-screen">
      <div className="welcome-content">
        <div className="welcome-logo welcome-animate-in">
          <img className="welcome-logo-img" src="/StratusEdgeFinal_whiteupscaled.png" alt="Edge AI" />
        </div>

        <div className="welcome-header">
          <h1 className="welcome-title welcome-animate-in">What would you like to know about Oracle HCM?</h1>
          <p className="welcome-subtitle welcome-animate-in welcome-animate-delay-1">Your AI consultant for Oracle HCM Cloud</p>
        </div>
      </div>
    </div>
  );
};

export default memo(WelcomeScreen);
